/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ResponseProcessingGroupDto } from '../../models/response-processing-group-dto';

export interface GetAllProcessingGroups$Params {
}

export function getAllProcessingGroups(http: HttpClient, rootUrl: string, params?: GetAllProcessingGroups$Params, context?: HttpContext): Observable<StrictHttpResponse<ResponseProcessingGroupDto>> {
  const rb = new RequestBuilder(rootUrl, getAllProcessingGroups.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ResponseProcessingGroupDto>;
    })
  );
}

getAllProcessingGroups.PATH = '/processinggroups';
